import type { PropsWithChildren } from 'react';

import type { ActiveExperiments } from '@/app/consts/activeExperiments';
import useStatsigExperiment from '@/app/hooks/useStatsigExperiment';

interface ExperimentComponentProps {
  readonly experimentName: ActiveExperiments;
  readonly control: React.ReactNode;
}

const ExperimentComponent = ({
  experimentName,
  control,
  children,
}: PropsWithChildren<ExperimentComponentProps>) => {
  const results = useStatsigExperiment(experimentName);
  return results.experience === 'Control' ? <>{control}</> : <>{children}</>;
};
export default ExperimentComponent;
